import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function PricingCTA() {
  return <section id="comprar" className="w-full py-20 md:py-32 px-6 bg-navy-light border-t border-navy-lighter relative overflow-hidden" data-id="element-87">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-warm-radial opacity-40 pointer-events-none" data-id="element-88" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy p-8 md:p-12 rounded-2xl border border-gold/30 shadow-2xl" data-id="element-90">
          <div className="mb-8" data-id="element-91">
            <span className="inline-block px-4 py-1 rounded-full bg-red-500/20 text-red-400 font-bold text-sm tracking-wider mb-4 border border-red-500/30" data-id="element-92">
              🔥 OFERTA POR TIEMPO LIMITADO — 66% OFF
            </span>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-93">
              <span className="text-3xl md:text-4xl text-cream-muted/50 line-through font-serif" data-id="element-94">
                $19
              </span>
              <h2 className="font-serif text-6xl md:text-7xl font-bold text-gold-bright" data-id="element-95">
                $6.39
              </h2>
            </div>
            <p className="text-xl text-cream-muted uppercase tracking-wide" data-id="element-96">
              Pago único
            </p>
          </div>

          <p className="text-xl md:text-2xl text-cream mb-10 font-serif leading-relaxed" data-id="element-97">
            Lo compras una vez y lo puedes consultar cada vez que el 3AM quiera
            volver.
          </p>

          <motion.a href="https://nexoselecto.com/cart/51789089079579:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto inline-flex items-center justify-center px-8 py-5 text-xl font-bold text-navy bg-gold hover:bg-gold-light transition-all duration-300 rounded-lg shadow-[0_0_20px_rgba(212,168,83,0.3)] hover:shadow-[0_0_30px_rgba(212,168,83,0.5)] mb-8" data-id="element-98">
            <span data-id="element-99">Descarga El Protocolo 3AM</span>
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-100" />
          </motion.a>

          <div className="flex items-center justify-center text-cream-muted mb-8" data-id="element-101">
            <ShieldCheck className="w-5 h-5 mr-2 text-gold" data-id="element-102" />
            <span className="text-sm" data-id="element-103">Pago seguro y encriptado</span>
          </div>

          <div className="border-t border-navy-lighter pt-8" data-id="element-104">
            <p className="text-lg md:text-xl text-cream italic mb-2" data-id="element-105">
              «Si hoy te despiertas a las 3AM, no necesitas ‹motivación›.
              Necesitas una ruta.»
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}